import RequestsTable from './RequestsTable/RequestsTable';

export default RequestsTable;
